export default {
      id: "icon-documents-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-documents",
      toString: function () {
        return this.url;
      }
    }